<div class="template-builder-container">

  <!-- Header -->
  <div class="builder-header">
    <div class="header-title">
      <button
        class="btn btn-outline-secondary btn-sm back-button"
        (click)="goToAppraisalsRoot()"
      >
        <i class="fa fa-arrow-left" aria-hidden="true"></i>
        <span>{{ getButtonLabel("BACK", "Back") }}</span>
      </button>
      <h3 translate>{{ isEditMode ? "EDIT_TEMPLATE" : "CREATE_TEMPLATE" }}</h3>
    </div>
    <div class="header-actions">
      <button class="btn btn-outline-secondary btn-cancel" (click)="cancel()">
        <i class="fa fa-times" aria-hidden="true"></i>
        <span>{{ getButtonLabel("CANCEL", "Cancel") }}</span>
      </button>
      <button
        class="btn btn-success btn-save"
        (click)="saveTemplate()"
        [disabled]="!canSaveTemplate()"
      >
        <i
          class="fa"
          [ngClass]="isSaving ? 'fa-spinner fa-spin' : 'fa-save'"
          aria-hidden="true"
        ></i>
        <span>{{
          isSaving
            ? getButtonLabel("SAVING", "Saving...")
            : getButtonLabel("SAVE_TEMPLATE", "Save Form")
        }}</span>
      </button>
    </div>
  </div>

  <!-- Wizard Steps -->
  <div class="wizard-steps">
    <div class="steps-container">
      <div
        *ngFor="let step of steps; let i = index"
        class="step-item"
        [class.active]="activeStep === i"
        [class.completed]="activeStep > i"
        (click)="goToStep(i)"
      >
        <div class="step-number">
          <i *ngIf="activeStep > i" class="fa fa-check" aria-hidden="true"></i>
          <span *ngIf="activeStep <= i">{{ i + 1 }}</span>
        </div>
        <div class="step-label" translate>{{ step.label }}</div>
      </div>
    </div>
    <div class="step-progress">
      <div
        class="progress-bar"
        [style.width.%]="((activeStep + 1) / steps.length) * 100"
      ></div>
    </div>
  </div>

  <!-- Step Content -->
  <div class="wizard-content">
    <!-- Step 1: Template Metadata -->
    <div *ngIf="activeStep === 0" class="step-content">
      <div class="step-title">
        <h4 translate>TEMPLATE_METADATA</h4>
        <p translate>TEMPLATE_METADATA_DESCRIPTION</p>
      </div>

      <form [formGroup]="templateForm" class="template-form">
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label translate
                >TEMPLATE_NAME <span class="required">*</span></label
              >
              <input
                type="text"
                class="form-control"
                formControlName="name"
                [placeholder]="'TEMPLATE_NAME_PLACEHOLDER' | translate"
                [class.is-invalid]="
                  templateForm.get('name')?.invalid &&
                  templateForm.get('name')?.touched
                "
              />
              <div
                class="invalid-feedback"
                *ngIf="
                  templateForm.get('name')?.invalid &&
                  templateForm.get('name')?.touched
                "
              >
                <span
                  *ngIf="templateForm.get('name')?.errors?.['required']"
                  translate
                  >FIELD_REQUIRED</span
                >
                <span
                  *ngIf="templateForm.get('name')?.errors?.['maxlength']"
                  translate
                  >MAX_LENGTH_200</span
                >
                <span
                  *ngIf="templateForm.get('name')?.errors?.['nameTaken']"
                  translate
                >
                  TEMPLATE_NAME_TAKEN
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-8">
            <div class="form-group">
              <label translate>DESCRIPTION</label>
              <textarea
                class="form-control"
                formControlName="description"
                rows="4"
                [placeholder]="'DESCRIPTION_PLACEHOLDER' | translate"
                [class.is-invalid]="
                  templateForm.get('description')?.invalid &&
                  templateForm.get('description')?.touched
                "
              >
              </textarea>
              <div
                class="invalid-feedback"
                *ngIf="
                  templateForm.get('description')?.invalid &&
                  templateForm.get('description')?.touched
                "
              >
                <span
                  *ngIf="templateForm.get('description')?.errors?.['maxlength']"
                  translate
                  >MAX_LENGTH_500</span
                >
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label translate>SIGNATURE_REQUIREMENT</label>
              <div class="form-check">
                <input
                  type="checkbox"
                  class="form-check-input"
                  id="requiresBothPartiesSignature"
                  formControlName="requiresBothPartiesSignature"
                />
                <label
                  class="form-check-label"
                  for="requiresBothPartiesSignature"
                  translate
                  >REQUIRES_BOTH_PARTIES_SIGNATURE</label
                >
              </div>
              <small class="form-text text-muted" translate>
                REQUIRES_BOTH_PARTIES_SIGNATURE_HELP
              </small>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-8" *ngIf="isEditMode">
            <div class="form-group">
              <label translate>LOAD_VERSION</label>
              <select
                class="form-control"
                [value]="selectedVersionTemplateId || ''"
                (change)="onVersionSourceChange($event)"
              >
                <option
                  *ngFor="let option of versionOptions"
                  [value]="option.templateId"
                >
                  {{ option.label }}
                </option>
              </select>
              <small class="form-text text-muted" translate
                >SELECT_VERSION_TO_LOAD</small
              >
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-8">
            <div class="form-group">
              <label translate>VERSION</label>
              <input
                type="number"
                class="form-control"
                formControlName="version"
                min="1"
                [readonly]="true"
                [class.is-invalid]="
                  templateForm.get('version')?.invalid &&
                  templateForm.get('version')?.touched
                "
              />
              <div
                class="invalid-feedback"
                *ngIf="
                  templateForm.get('version')?.invalid &&
                  templateForm.get('version')?.touched
                "
              >
                <span
                  *ngIf="templateForm.get('version')?.errors?.['min']"
                  translate
                  >VERSION_MUST_BE_POSITIVE</span
                >
                <span
                  *ngIf="templateForm.get('version')?.errors?.['nameTaken']"
                  translate
                >
                  TEMPLATE_NAME_VERSION_TAKEN
                </span>
              </div>
              <small
                class="form-text text-muted"
                *ngIf="isEditMode && suggestedVersion"
              >
                {{ "NEXT_VERSION_SUGGESTION" | translate }} {{ suggestedVersion
                }}
              </small>
              <small class="form-text text-muted" *ngIf="isEditMode" translate>
                VERSION_AUTO_GENERATED_ON_SAVE
              </small>
            </div>
          </div>
        </div>
      </form>
    </div>

    <!-- Step 2: Sections Management -->
    <div *ngIf="activeStep === 1" class="step-content">
      <div class="step-title">
        <h4 translate>SECTIONS</h4>
        <p translate>SECTIONS_DESCRIPTION</p>
      </div>

      <div class="sections-toolbar" *ngIf="sectionsArray.length > 0">
        <button class="btn btn-primary btn-add-section" (click)="addSection()">
          <i class="fa fa-plus" aria-hidden="true"></i>
          <span translate>ADD_SECTION</span>
        </button>
      </div>

      <div
        class="sections-list"
        cdkDropList
        (cdkDropListDropped)="dropSection($event)"
      >
        <div
          *ngFor="let section of sectionsArray.controls; let i = index"
          class="section-item"
          cdkDrag
        >
          <div class="section-header">
            <div class="drag-handle" cdkDragHandle>
              <i class="fa fa-bars" aria-hidden="true"></i>
            </div>
            <div class="section-info">
              <span class="section-number">{{ i + 1 }}</span>
              <span class="section-title">{{
                section.get("title")?.value || ("UNTITLED_SECTION" | translate)
              }}</span>
            </div>
            <div class="section-actions">
              <button
                class="btn btn-sm btn-danger"
                (click)="removeSection(i)"
                [title]="'DELETE' | translate"
              >
                <i class="fa fa-trash" aria-hidden="true"></i>
              </button>
            </div>
          </div>

          <div class="section-body" [formGroup]="section">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label translate
                    >SECTION_TITLE <span class="required">*</span></label
                  >
                  <input
                    type="text"
                    class="form-control"
                    formControlName="title"
                    [placeholder]="'SECTION_TITLE_PLACEHOLDER' | translate"
                    [class.is-invalid]="
                      section.get('title')?.invalid &&
                      section.get('title')?.touched
                    "
                  />
                  <div
                    class="invalid-feedback"
                    *ngIf="
                      section.get('title')?.invalid &&
                      section.get('title')?.touched
                    "
                  >
                    <span
                      *ngIf="section.get('title')?.errors?.['required']"
                      translate
                      >FIELD_REQUIRED</span
                    >
                    <span
                      *ngIf="section.get('title')?.errors?.['maxlength']"
                      translate
                      >MAX_LENGTH_200</span
                    >
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label translate>SECTION_DESCRIPTION</label>
                  <textarea
                    class="form-control"
                    formControlName="description"
                    rows="2"
                    [placeholder]="
                      'SECTION_DESCRIPTION_PLACEHOLDER' | translate
                    "
                    [class.is-invalid]="
                      section.get('description')?.invalid &&
                      section.get('description')?.touched
                    "
                  >
                  </textarea>
                  <div
                    class="invalid-feedback"
                    *ngIf="
                      section.get('description')?.invalid &&
                      section.get('description')?.touched
                    "
                  >
                    <span
                      *ngIf="section.get('description')?.errors?.['maxlength']"
                      translate
                      >MAX_LENGTH_500</span
                    >
                  </div>
                </div>
              </div>
            </div>

            <div class="questions-count">
              <i class="fa fa-question-circle" aria-hidden="true"></i>
              <span>{{ section.get("questions")?.value?.length || 0 }} </span>
              <span translate>QUESTIONS</span>
            </div>
          </div>
        </div>

        <div *ngIf="sectionsArray.length === 0" class="empty-state">
          <i class="fa fa-list-ul empty-state-icon" aria-hidden="true"></i>
          <p translate>NO_SECTIONS_YET</p>
          <button class="btn btn-primary btn-add-first-section" (click)="addSection()">
            <i class="fa fa-plus" aria-hidden="true"></i>
            <span translate>ADD_FIRST_SECTION</span>
          </button>
        </div>
      </div>

      <div
        class="sections-toolbar"
        *ngIf="sectionsArray.length > 0"
        style="margin-top: 20px; margin-bottom: 0;"
      >
        <button class="btn btn-primary btn-add-section" (click)="addSection()">
          <i class="fa fa-plus" aria-hidden="true"></i>
          <span translate>ADD_SECTION</span>
        </button>
      </div>
    </div>

    <!-- Step 3: Questions Management -->
    <div *ngIf="activeStep === 2" class="step-content">
      <div class="step-title">
        <h4 translate>QUESTIONS</h4>
        <p translate>QUESTIONS_DESCRIPTION</p>
      </div>

      <div *ngIf="sectionsArray.length > 0" class="questions-container">
        <!-- Section Selector -->
        <div class="section-selector">
          <label translate>SELECT_SECTION</label>
          <div class="section-tabs">
            <button
              *ngFor="let section of sectionsArray.controls; let i = index"
              class="section-tab"
              [class.active]="currentSectionIndex === i"
              (click)="selectSection(i)"
            >
              <span class="tab-number">{{ i + 1 }}</span>
              <span class="tab-title">{{
                section.get("title")?.value ||
                  ("SECTION" | translate) + " " + (i + 1)
              }}</span>
              <span class="tab-count"
                >({{ section.get("questions")?.value?.length || 0 }})</span
              >
            </button>
          </div>
        </div>

        <!-- Questions for Selected Section -->
        <div class="questions-toolbar">
          <button class="btn btn-primary btn-add-question" (click)="addQuestion()">
            <i class="fa fa-plus" aria-hidden="true"></i>
            <span translate>ADD_QUESTION</span>
          </button>
        </div>

        <div
          class="questions-list"
          cdkDropList
          (cdkDropListDropped)="dropQuestion($event)"
        >
          <div
            *ngFor="
              let question of getQuestionsForCurrentSection().controls;
              let qi = index
            "
            class="question-item"
            cdkDrag
          >
            <div class="question-header">
              <div class="drag-handle" cdkDragHandle>
                  <i class="fa fa-bars" aria-hidden="true"></i>
              </div>
              <div class="question-info">
                <span class="question-number">Q{{ qi + 1 }}</span>
                <span class="question-text">{{
                  question.get("questionText")?.value ||
                    ("UNTITLED_QUESTION" | translate)
                }}</span>
              </div>
              <div class="question-actions">
                <button
                  class="btn btn-sm btn-danger"
                  (click)="removeQuestion(qi)"
                  [title]="'DELETE' | translate"
                >
                  <i class="fa fa-trash" aria-hidden="true"></i>
                </button>
              </div>
            </div>

            <div class="question-body" [formGroup]="question">
              <div class="row">
                <div class="col-md-8">
                  <div class="form-group">
                    <label translate
                      >QUESTION_TEXT <span class="required">*</span></label
                    >
                    <input
                      type="text"
                      class="form-control"
                      formControlName="questionText"
                      [placeholder]="'QUESTION_TEXT_PLACEHOLDER' | translate"
                      [class.is-invalid]="
                        question.get('questionText')?.invalid &&
                        question.get('questionText')?.touched
                      "
                    />
                    <div
                      class="invalid-feedback"
                      *ngIf="
                        question.get('questionText')?.invalid &&
                        question.get('questionText')?.touched
                      "
                    >
                      <span
                        *ngIf="
                          question.get('questionText')?.errors?.['required']
                        "
                        translate
                        >FIELD_REQUIRED</span
                      >
                      <span
                        *ngIf="
                          question.get('questionText')?.errors?.['maxlength']
                        "
                        translate
                        >MAX_LENGTH_500</span
                      >
                    </div>
                  </div>
                </div>

                <div class="col-md-4">
                  <div class="form-group">
                    <label translate
                      >QUESTION_TYPE <span class="required">*</span></label
                    >
                    <select class="form-control" formControlName="questionType">
                      <option
                        *ngFor="let type of questionTypeOptions"
                        [value]="type.value"
                      >
                        {{ type.labelKey | translate }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-4">
                  <div class="form-check">
                    <input
                      type="checkbox"
                      class="form-check-input"
                      [id]="'qRequired_' + qi"
                      formControlName="isRequired"
                    />
                    <label
                      class="form-check-label"
                      [for]="'qRequired_' + qi"
                      translate
                      >REQUIRED</label
                    >
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-check">
                    <input
                      type="checkbox"
                      class="form-check-input"
                      [id]="'qEmpVisible_' + qi"
                      formControlName="isEmployeeVisible"
                      (change)="onQuestionVisibilityChanged(question, 'employee')"
                    />
                    <label
                      class="form-check-label"
                      [for]="'qEmpVisible_' + qi"
                      translate
                      >EMPLOYEE_PARTICIPATES</label
                    >
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-check">
                    <input
                      type="checkbox"
                      class="form-check-input"
                      [id]="'qMgrVisible_' + qi"
                      formControlName="isManagerVisible"
                      (change)="onQuestionVisibilityChanged(question, 'manager')"
                    />
                    <label
                      class="form-check-label"
                      [for]="'qMgrVisible_' + qi"
                      translate
                      >MANAGER_PARTICIPATES</label
                    >
                  </div>
                </div>
              </div>

              <div class="question-permissions">
                <div class="permission-group">
                  <div class="permission-group-title" translate>CAN_ANSWER</div>
                  <div class="permission-options">
                    <div
                      class="form-check"
                      *ngIf="question.get('isEmployeeVisible')?.value"
                    >
                      <input
                        type="checkbox"
                        class="form-check-input"
                        [id]="'qEmpCanAnswer_' + qi"
                        formControlName="employeeCanAnswer"
                      />
                      <label
                        class="form-check-label"
                        [for]="'qEmpCanAnswer_' + qi"
                        translate
                        >EMPLOYEE_CAN_ANSWER</label
                      >
                    </div>
                    <div
                      class="form-check"
                      *ngIf="question.get('isManagerVisible')?.value"
                    >
                      <input
                        type="checkbox"
                        class="form-check-input"
                        [id]="'qMgrCanAnswer_' + qi"
                        formControlName="managerCanAnswer"
                      />
                      <label
                        class="form-check-label"
                        [for]="'qMgrCanAnswer_' + qi"
                        translate
                        >MANAGER_CAN_ANSWER</label
                      >
                    </div>
                  </div>
                </div>
                <small
                  *ngIf="!hasQuestionVisibleParticipant(question)"
                  class="permission-warning"
                  translate
                >
                  QUESTION_MUST_HAVE_VISIBLE_PARTICIPANT
                </small>
                <small
                  *ngIf="hasQuestionVisibleParticipant(question) && !hasQuestionAnswerer(question)"
                  class="permission-warning"
                  translate
                >
                  QUESTION_MUST_HAVE_ANSWERER
                </small>
              </div>

              <!-- Likert Scale Options -->
              <div
                *ngIf="question.get('questionType')?.value === 0"
                class="row"
              >
                <div class="col-md-6">
                  <div class="form-group">
                    <label translate>LIKERT_LOW_LABEL</label>
                    <input
                      type="text"
                      class="form-control"
                      formControlName="likertLowLabel"
                      [placeholder]="'DISAGREE' | translate"
                      [class.is-invalid]="
                        question.get('likertLowLabel')?.invalid &&
                        question.get('likertLowLabel')?.touched
                      "
                    />
                    <div
                      class="invalid-feedback"
                      *ngIf="
                        question.get('likertLowLabel')?.invalid &&
                        question.get('likertLowLabel')?.touched
                      "
                    >
                      <span translate>MAX_LENGTH_50</span>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label translate>LIKERT_HIGH_LABEL</label>
                    <input
                      type="text"
                      class="form-control"
                      formControlName="likertHighLabel"
                      [placeholder]="'AGREE' | translate"
                      [class.is-invalid]="
                        question.get('likertHighLabel')?.invalid &&
                        question.get('likertHighLabel')?.touched
                      "
                    />
                    <div
                      class="invalid-feedback"
                      *ngIf="
                        question.get('likertHighLabel')?.invalid &&
                        question.get('likertHighLabel')?.touched
                      "
                    >
                      <span translate>MAX_LENGTH_50</span>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>

          <div
            *ngIf="getQuestionsForCurrentSection().length === 0"
            class="empty-state"
          >
            <i class="fa fa-question-circle empty-state-icon" aria-hidden="true"></i>
            <p translate>NO_QUESTIONS_YET</p>
            <button class="btn btn-primary btn-add-question" (click)="addQuestion()">
              <i class="fa fa-plus" aria-hidden="true"></i>
              <span translate>ADD_FIRST_QUESTION</span>
            </button>
          </div>
        </div>

        <div class="questions-toolbar" *ngIf="getQuestionsForCurrentSection().length > 0">
          <button class="btn btn-primary btn-add-question" (click)="addQuestion()">
            <i class="fa fa-plus" aria-hidden="true"></i>
            <span translate>ADD_QUESTION</span>
          </button>
        </div>
      </div>

      <div *ngIf="sectionsArray.length === 0" class="empty-state">
        <i class="fa fa-exclamation-triangle empty-state-icon" aria-hidden="true"></i>
        <p translate>NO_SECTIONS_CREATED</p>
        <button class="btn btn-secondary" (click)="previousStep()">
          <i class="fa fa-arrow-left" aria-hidden="true"></i>
          <span translate>GO_BACK_ADD_SECTIONS</span>
        </button>
      </div>
    </div>
  </div>

  <!-- Wizard Navigation -->
  <div class="wizard-footer">
    <button
      class="btn btn-secondary"
      (click)="previousStep()"
      [disabled]="activeStep === 0"
    >
      <i class="fa fa-arrow-left" aria-hidden="true"></i>
      <span translate>PREVIOUS</span>
    </button>

    <div class="footer-info">
      <span translate>STEP</span> {{ activeStep + 1 }} / {{ steps.length }}
      <span *ngIf="hasUnsavedChanges" class="unsaved-badge">
        <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
        <span translate>UNSAVED_CHANGES</span>
      </span>
    </div>

    <button
      *ngIf="activeStep < steps.length - 1"
      class="btn btn-primary"
      (click)="nextStep()"
    >
      <span translate>NEXT</span>
      <i class="fa fa-arrow-right" aria-hidden="true"></i>
    </button>

    <button
      *ngIf="activeStep === steps.length - 1"
      class="btn btn-success btn-save"
      (click)="saveTemplate()"
      [disabled]="!canSaveTemplate()"
    >
      <i
        class="fa"
        [ngClass]="isSaving ? 'fa-spinner fa-spin' : 'fa-save'"
        aria-hidden="true"
      ></i>
      <span>{{
        isSaving
          ? getButtonLabel("SAVING", "Saving...")
          : getButtonLabel("SAVE_TEMPLATE", "Save Form")
      }}</span>
    </button>
  </div>
</div>

<p-confirmDialog [style]="{ width: '450px' }"></p-confirmDialog>
